export default "/assets/images/column-image4.da22ace44211b3f7.webp";